type IconProps = {
  size?: number;
  class?: string;
};

export function CheckIcon({ size = 20, class: className }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      class={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m5 12 4 4 10-10" />
    </svg>
  );
}

export function ChevronDownIcon({ size = 20, class: className }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      class={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}

export function DownloadIcon({ size = 20, class: className }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      class={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M12 3v12m0 0 4-4m-4 4-4-4M5 19h14" />
    </svg>
  );
}

export function CalendarIcon({ size = 20, class: className }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      class={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M8 3v4M16 3v4M3 10h18" />
      <g fill="currentColor" stroke="none">
        <circle cx="8" cy="14" r="1" />
        <circle cx="12" cy="14" r="1" />
        <circle cx="16" cy="14" r="1" />
        <circle cx="8" cy="18" r="1" />
        <circle cx="12" cy="18" r="1" />
        <circle cx="16" cy="18" r="1" />
      </g>
    </svg>
  );
}

export function ChevronRightIcon({ size = 20, class: className }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      class={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

export function FileTextIcon({ size = 20, class: className }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      class={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6Z" />
      <path d="M14 3v6h6M8 13h8m-8 4h8" />
    </svg>
  );
}

export function SettingsIcon({ size = 20, class: className }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      class={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m9 3-1 3-2 1-3-.5-1 3L4 12l-2 2.5 1 3 3-.5 2 1 1 3h6l1-3 2-1 3 .5 1-3L20 12l2-2.5-1-3-3 .5-2-1-1-3Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export function EmailIcon({ size = 20 }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 6 9 7 9-7" />
    </svg>
  );
}
